export const primaryNav = [
  { to: "/", label: "Home" },
  {
    to: "/products-services",
    label: "Solutions",
    children: [
      { to: "/maginsight", label: "MAG Insight" },
      { to: "/catalog", label: "AMR Catalog" },
    ],
  },
  { to: "/mag-lab", label: "MAG Lab" },
  { to: "/who-we-are", label: "About" },
];

export const contactLink = { to: "/contact", label: "Contact Us" };
